import moment from 'moment'
import { TimeOff } from '../types/TimeOff'

export const useTimeoffCalculator = () => {
  const countWeekendDays = (startDate, endDate) => {
    let count = 0
    const currentDate = startDate.clone()

    while (currentDate.isSameOrBefore(endDate, 'day')) {
      if (currentDate.day() === 0 || currentDate.day() === 6) {
        count++
      }
      currentDate.add(1, 'day')
    }

    return count
  }
  const clipToCurrentYear = (timeoff: TimeOff) => {
    const currentYear = moment().year()
    const yearStart = moment({ year: currentYear, month: 0, date: 1 })
    const yearEnd = moment({ year: currentYear, month: 11, date: 31 })

    let startDate = moment(timeoff.startDate)
    let endDate = moment(timeoff.endDate)

    if (
      endDate.isBefore(yearStart, 'day') ||
      startDate.isAfter(yearEnd, 'day')
    ) {
      return null
    }

    startDate = moment.max(startDate, yearStart)
    endDate = moment.min(endDate, yearEnd)

    return { startDate, endDate }
  }

  const getTotalDaysUsed = (allTimesOff: TimeOff[]) => {
    const today = moment()

    return allTimesOff.reduce((total, timeoff) => {
      const clipped = clipToCurrentYear(timeoff)
      const startDate = clipped ? clipped.startDate : today
      if (!clipped) return total

      let { endDate } = clipped
      if (startDate.isAfter(today, 'day')) return total
      endDate = moment.min(endDate, today)

      const weekends = countWeekendDays(startDate, endDate)
      const duration = endDate.diff(startDate, 'days') + 1
      total += Math.max(duration - weekends, 0)

      return total
    }, 0)
  }

  const getTotalDaysScheduled = (allTimesOff: TimeOff[]) => {
    return allTimesOff.reduce((total, timeoff) => {
      const clipped = clipToCurrentYear(timeoff)
      if (!clipped) return total

      const { startDate, endDate } = clipped
      const weekends = countWeekendDays(startDate, endDate)
      const duration = endDate.diff(startDate, 'days') + 1
      total += Math.max(duration - weekends, 0)

      return total
    }, 0)
  }
  const getRemainingDays = (allTimesOff: TimeOff[]) => {
    const totalDaysUsed = getTotalDaysUsed(allTimesOff)
    const totalDaysScheduled = getTotalDaysScheduled(allTimesOff)
    const remainingDays = Math.max(totalDaysScheduled - totalDaysUsed, 0)

    return remainingDays
  }
  return {
    getTotalDaysScheduled,
    getTotalDaysUsed,
    getRemainingDays,
  }
}
